var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnpublish(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.3335 3.33268C3.3335 3.69935 3.6335 3.99935 4.00016 3.99935H12.0002C12.3668 3.99935 12.6668 3.69935 12.6668 3.33268C12.6668 2.96602 12.3668 2.66602 12.0002 2.66602H4.00016C3.6335 2.66602 3.3335 2.96602 3.3335 3.33268ZM4.94016 9.33268H6.00016V12.666C6.00016 13.0327 6.30016 13.3327 6.66683 13.3327H9.3335C9.70016 13.3327 10.0002 13.0327 10.0002 12.666V9.33268H11.0602C11.6535 9.33268 11.9535 8.61268 11.5335 8.19268L8.4735 5.13268C8.41182 5.07088 8.33856 5.02185 8.25791 4.98839C8.17726 4.95494 8.09081 4.93772 8.0035 4.93772C7.91618 4.93772 7.82973 4.95494 7.74908 4.98839C7.66843 5.02185 7.59517 5.07088 7.5335 5.13268L4.4735 8.19268C4.0535 8.61268 4.34683 9.33268 4.94016 9.33268Z",
    fill: "#404040"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15.5C11.3873 15.5 12.5 14.3873 12.5 13C12.5 11.6127 11.3873 10.5 10 10.5C8.61275 10.5 7.5 11.6127 7.5 13C7.5 14.3873 8.61275 15.5 10 15.5Z",
    fill: "#404040",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpublish);
export default __webpack_public_path__ + "static/media/unpublish.c3b2011d5f15532c92eff41401b9de6c.svg";
export { ForwardRef as ReactComponent };